import { gql } from "@/__generated__/gql";

export const CONTEXT_METRICS = gql(`
query contextMetrics($orgId: ID!, $context:OrganizationMetricsContextEnum!) {
  node(id: $orgId) {
    id
    ... on Organization {
      metrics(context: $context){
        name
        value
        previousCycleValue
      }
    }
  }
}
`);
